import React, { useState, createContext, useContext} from 'react';
import LayoutNavSectionList from 'components/layout/LayoutNavSectionList.jsx';
import LayoutDownloadButtonsSection from 'components/layout/LayoutDownloadButtonsSection.jsx';
import LayoutContext from 'components/contexts/LayoutContext.jsx';

const ShowLayoutPage = ( {navSections, dimensionGroups, userSavedCustomDimensions, layoutOptions, formulaOptions, optionsUserEntered, unit, locale, theme, btn_action, dimension_texts_on_layouts_enabled} ) => {
  const LayoutContextValues = {
    dimensionGroups: dimensionGroups,
    userSavedCustomDimensions: userSavedCustomDimensions || [],
    layoutOptions: layoutOptions,
    formulaOptions: formulaOptions,
    optionsUserEntered: optionsUserEntered,
    unit: unit,
    locale: locale,
    theme: theme,
    btn_action: btn_action,
    dimension_texts_on_layouts_enabled: dimension_texts_on_layouts_enabled,
  }

  // When combo guests are present, downloads are per-section (rendered inside
  // each LayoutNavSection). The page-level bar (which would otherwise hold the
  // host-only download buttons + the Quote Builder CTA) is hidden — quote builder
  // for combos lands in a follow-up.
  const comboGuestPresent = (navSections || []).some((section) => {
    const sectionMembers = (section.members || []).concat((section.sub_sections || []).flatMap((sub) => sub.members || []));
    return sectionMembers.some((member) => member && member.is_combo_guest);
  });

  return (
     <LayoutContext.Provider value={LayoutContextValues} >
        <div >
          <div className="container">
            <LayoutNavSectionList navSections={navSections} comboGuestPresent={comboGuestPresent} />
          </div>

          {!comboGuestPresent && (
            <div className="container">
              <LayoutDownloadButtonsSection />
            </div>
          )}

        </div>
     </LayoutContext.Provider>
  )
};

export default ShowLayoutPage;
